module.exports = __webpack_public_path__ + "static/img/icon_logo.fd1ca3c1.png";